import {
  BusinessModalName,
  BusinessModalNames,
  CallState,
  CorpBusinessAccount,
  CorpSessionInfo,
  ICorpPerson,
  IPerson,
  ModalDataMap,
  PolicyTier,
  RewardsAccount,
  SessionInfo,
} from "redmond";
import {
  B2bBaseActions,
  DELETE_USER_PASSENGER,
  FETCH_CORP_USER_PASSENGERS,
  SET_BUSINESS_ACCOUNTS,
  SET_IS_MULTIPORTAL,
  SET_MODAL_METADATA_INFO,
  SET_POLICY_TIER,
  SET_REWARDS_ACCOUNTS,
  SET_SELECTED_ACCOUNT_REFERENCE_ID,
  SET_SESSION_INFO,
  SET_USER_PASSENGERS,
  SET_USER_PASSENGERS_CALL_STATE_FAILED,
  SET_USER_SELECTED_PASSENGER_IDS,
  UPDATE_USER_PASSENGER,
} from "./actions";

export interface B2bBaseState {
  sessionInfo: SessionInfo | CorpSessionInfo | undefined;
  corpBusinessAccounts?: CorpBusinessAccount[];
  rewardsAccounts: RewardsAccount[];
  policyTier?: PolicyTier;
  selectedAccountReferenceId: string | null;
  modalMetadata: { [K in BusinessModalNames]?: ModalDataMap[K] } | null;
  hasSeenModalMap: Record<BusinessModalName, boolean> | null;
  userPassengers: IPerson[] | ICorpPerson[];
  userPassengerCallState: CallState;
  userSelectedTravelerId: string | null;
  isMultiportal: boolean;
}

const initialState: B2bBaseState = {
  sessionInfo: undefined,
  corpBusinessAccounts: undefined,
  rewardsAccounts: [],
  policyTier: undefined,
  selectedAccountReferenceId: null,
  modalMetadata: null,
  hasSeenModalMap: null,
  userPassengers: [],
  userPassengerCallState: CallState.NotCalled,
  userSelectedTravelerId: null,
  isMultiportal: false,
};

export function rootReducer(
  state = initialState,
  action: B2bBaseActions
): B2bBaseState {
  switch (action.type) {
    case SET_SESSION_INFO:
      return {
        ...state,
        sessionInfo: action.sessionInfo,
      };
    case SET_BUSINESS_ACCOUNTS:
      return {
        ...state,
        corpBusinessAccounts: action.businessAccounts,
      };
    case SET_REWARDS_ACCOUNTS:
      return {
        ...state,
        rewardsAccounts: action.rewardsAccounts,
      };

    case SET_SELECTED_ACCOUNT_REFERENCE_ID:
      return {
        ...state,
        selectedAccountReferenceId: action.selectedAccountReferenceId,
      };

    case SET_MODAL_METADATA_INFO:
      return {
        ...state,
        modalMetadata: action.metadata,
        hasSeenModalMap: action.hasSeenModalMap,
      };

    case SET_POLICY_TIER:
      return {
        ...state,
        policyTier: action.policyTier,
      };

    case FETCH_CORP_USER_PASSENGERS:
      return {
        ...state,
        userPassengerCallState: CallState.InProcess,
      };

    case UPDATE_USER_PASSENGER:
      return {
        ...state,
        userPassengerCallState: CallState.InProcess,
      };

    case DELETE_USER_PASSENGER:
      return {
        ...state,
        userPassengerCallState: CallState.InProcess,
      };

    case SET_USER_PASSENGERS:
      return {
        ...state,
        userPassengerCallState: CallState.Success,
        userPassengers: [...action.userPassengers],
      };

    case SET_USER_SELECTED_PASSENGER_IDS:
      return {
        ...state,
        // Note: we only want to select a single traveler here.
        // We are also accounting for this in the halifax traveler workflow with the prop singleTravelerWorkflow
        userSelectedTravelerId: action.userSelectedPassengerIds[0],
      };

    case SET_USER_PASSENGERS_CALL_STATE_FAILED:
      return {
        ...state,
        userPassengerCallState: CallState.Failed,
      };

    case SET_IS_MULTIPORTAL:
      return {
        ...state,
        isMultiportal: action.isMultiportal,
      };

    default:
      return state;
  }
}
